<div class="sq-dialog">
    <header class="sq-dialog__header">  
        <div class="sq-dialog__header-text">
            <!-- <p class="sq-dialog__meta" *ngIf="data.feedBackDate">{{ data.feedBackDate }}</p> -->
            <h6 class="sq-dialog__meta_name" *ngIf="data.studentName">Student Name: {{ data.studentName }}</h6>
            <h6 class="sq-dialog__meta_name" *ngIf="data.admNo">Adm No: {{ data.admNo }}</h6>
            <h2 class="sq-dialog__title">Answer Details</h2>
        </div>
        <button type="button" class="sq-dialog__close" (click)="close()" aria-label="Close dialog">
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
    </header>

    <div class="sq-dialog__body">
        <p class="sq-dialog__question">
            {{ data.questionLabel }}. {{ data.question }}
        </p>

        <div *ngFor="let opt of data.options" class="sq-dialog__answer" [ngStyle]="{
            'border-color': getRankStyles(opt.optionRank).border,
            'background-color': getRankStyles(opt.optionRank).background
        }">
            <span class="sq-dialog__rank" [ngStyle]="{ 'background-color': getRankStyles(opt.optionRank).circle }">
                {{ normalizeRank(opt.optionRank) }}
            </span>
            <span class="sq-dialog__answer-text">{{ opt.feedbackOptionText }}</span>
        </div>
    </div>
</div>
